import AdminSettings from "./AdminSettings";

export default AdminSettings;
